var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClassName},[(_vm.directoryIcon)?_c(_vm.directoryIcon,{tag:"component",class:_vm.$style.icon,attrs:{"name":_vm.item.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }